module.exports = __webpack_public_path__ + "static/img/hala25.9574e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hala/hala25.jpg
// module id = qh/9
// module chunks = 1